import React from 'react';
import { Search } from './components/Search';
import { CreateBtn } from './components/CreateBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import { ModifierGroupSelect } from './components/ModifierGroupSelect';
import { ResetBtn } from './components/ResetBtn';
import { SortBy } from './components/SortBy/SortBy';
import { CountOfItem } from './components/CountOfItem';
import { IsDisabledCheckbox } from './components/IsDisabledCheckbox';
import { IsRestrictedCheckbox } from './components/IsRestrictedCheckbox';
import { WithURLFilters } from './components/WithURLFilters';
import style from './ModifiersControlPanel.module.scss';

export const ModifiersControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.filteringControls}>
					<div className={style.selectWrapper}>
						<CustomerSelect />
						<RestaurantSelect />
						<ModifierGroupSelect />
					</div>
					<div className={style.checkBoxesWrapper}>
						<IsDisabledCheckbox />
						<IsRestrictedCheckbox />
					</div>
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};
